<template>
  <!-- 对话框 -->
  <el-dialog :title="name+'的账单'" :visible.sync="show" :before-close="closeDialog" width="70%">

    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">

      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <div>
              <el-form-item label="对应表:">
                <span>{{ props.row.table_name }}</span>
              </el-form-item>
            </div>

            <div>
              <el-form-item label="相关编号:">
                <span>{{ props.row.record_code }}</span>
              </el-form-item>
            </div>


            <div>
              <el-form-item label="备注:">
                <span>{{ props.row.remark }}</span>
              </el-form-item>
            </div>


          </el-form>
        </template>
      </el-table-column>


      <el-table-column prop="id" label="id">
      </el-table-column>

      <el-table-column prop="operation.alias" label="账户操作">
      </el-table-column>

      <el-table-column prop="amount" label="金额">
      </el-table-column>

      <el-table-column prop="description" label="描述">
      </el-table-column>

      <el-table-column prop="surplus" label="结算后余额">
      </el-table-column>

      <el-table-column prop="time.YmdHis" label="创建时间">
      </el-table-column>

      <el-table-column prop="mode.alias" label="账本模式">
      </el-table-column>



    </el-table>


    <!-- 分页组件 -->
    <div style="text-align: right;">
      <el-pagination layout="prev, pager, next" :total="result_data_children.count" @current-change="pages_function">
      </el-pagination>
    </div>



    <div style="display: flex;justify-content: center">
      <el-button @click="closeDialog">关闭</el-button>
    </div>



  </el-dialog>
</template>

<script>
  var _this;

  export default {
    props: {
      'isShow': Boolean,
      'data': '',
      'name': '',
      'phone':''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        _this.search_data_children.consumer_code = _this.data
        _this.search_data_children.phone = _this.phone

        console.log(_this.data);

        _this.recordInit();

      },

    },
    data() {
      return {

        show: false,

        tableData: [],


        //翻页数据
        search_data_children: {
          page: 1,
          limit: 10,
          consumer_code: '',
          phone:''
        },

        result_data_children: [],
        search_rules_children: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {
      // 获取钱包信息
      recordInit() {
        _this.$post(
            '/consumer/consumerRecordLists',
            _this.search_data_children,
            _this.search_rules_children
          )
          .then(res => {

            // 将获取到的数据赋值

            _this.tableData = res.data;
            _this.result_data_children = res;
            console.log(res.data);


          }).catch((err) => {

          })
      },
      // 关闭方法
      closeDialog() {

        _this.show = false;

        _this.search_data_children= {
          page: 1,
          limit: 10,
          consumer_code: '',
          phone:''
        };
        _this.tableData= [];
        console.log(_this.tableData,'_this.tableData');

      

      },

      //翻页组件的回调
      pages_function(val) {
        _this.search_data_children.page = val;

        //初始化列表
        _this.recordInit();

      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>
